import axios from 'axios';
import type { StudioDisplayModel } from '@shared/models/studios/studios';
import { axiosToServiceResult } from '@shared/axios';

export const getStudioDetails = async (studioSlug: string) =>
  await axiosToServiceResult(axios.get<StudioDisplayModel>(`/api/customer/studios/${studioSlug}`));
